import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import { getVistaDatosPresupuestoInternoRenglon, getDatosPresupuestoInternoRenglon } from '../../helpers/user_mv';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,

    /* Vista de datos de un presupuesto interno */
    presupuestoDatos: [],
    ordenesDatos: [],
    ordenesDatosTotales: [],
    presupuestoTotalesDatos: [],
    vistaOrdenesDatos: [],
    vistaOrdenesDatosTotales: [],
    aperturasCierresDatos: [],
    
    ordenTrabajoAlternativas: {},
    ordenesAlternativasDatos: [],
    facturacionDatos: [],
    usuariosDatos: [],
    usuariosPropuestaDatos: [],

    vendedoresComisiones: [],

    presupuestoDatosRpt: []
};

const mutations = {
    updateField,

    'INICIALIZAR_DATOS' (state) {
        state.presupuestoDatos = [];
        state.ordenesDatos = [];
        state.presupuestoTotalesDatos = [];
        state.aperturasCierresDatos = [];
        
        state.ordenTrabajoAlternativas = {};
        state.ordenesAlternativasDatos = [];
        state.facturacionDatos = [];
        state.usuariosDatos = [];
        state.usuariosPropuestaDatos = [];

        state.vendedoresComisiones = [];

        state.presupuestoDatosRpt = {};
    },
    'SET_VISTA_ORDENES' (state, vista) {
        state.vistaOrdenesDatos =  vista;
    },
    'SET_PRESUPUESTO_DATOS' (state, params) {
        state.presupuestoDatos = params.presupuestoDatos;
        state.ordenesDatos = params.ordenesDatos.map(ordenTrabajo => ({
            ...ordenTrabajo,
            cotizacionFinal: parseFloat(ordenTrabajo.cotizacion) + parseFloat(ordenTrabajo.importeFeeAgencia) + parseFloat(ordenTrabajo.importeFinanciacion),
            tieneAlternativas: ordenTrabajo.alternativas.length != 0,
            _rowVariant: parseFloat(ordenTrabajo.pjeRentabilidadReal) < 0 ? 'danger' : ''
        }));

        state.aperturasCierresDatos = params.aperturasCierresDatos;
        state.usuariosDatos = params.usuarios.sort(function(a, b){
            /* Ordenamos por Rol y Nombre */
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
        state.usuariosPropuestaDatos = params.usuariosPropuesta.sort(function(a, b){
            /* Ordenamos por Rol y Nombre */
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        /* Vendedores Comisiones */
        if (Array.isArray(params.presupuestoDatos.vendedoresComisiones) && params.presupuestoDatos.vendedoresComisiones.length > 0) {
            state.vendedoresComisiones = params.presupuestoDatos.vendedoresComisiones.map(vendedorComision => ( {
                vendedor: vendedorComision.vendedor,
                personal: vendedorComision.personal,
                comisionInterna: vendedorComision.comisionInterna,
                tipoComision: vendedorComision.tipoComision,
                tipoPjeComision: vendedorComision.tipoPjeComision,
                pjeComision: vendedorComision.pjeComision,
                importe: vendedorComision.importe,
                montoBaseComision: vendedorComision.montoBaseComision,
                montoComision: vendedorComision.montoComision,
                montoCompras: vendedorComision.montoCompras,
                montoCancelado: vendedorComision.montoCancelado,
                saldo: parseFloat(vendedorComision.montoComision) 
                    - parseFloat(vendedorComision.montoCompras)
                    - parseFloat(vendedorComision.montoCancelado)
            }));
        }

        state.facturacionDatos = params.facturacion
            .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        setPresupuestoDatosRpt(state);
    },
    'CONSULTAR_ALTERNATIVAS' (state, ordenTrabajoId) {
        state.ordenTrabajoAlternativas = state.ordenesDatos.find(ordenTrabajo => ordenTrabajo.id == ordenTrabajoId);
        if (state.ordenTrabajoAlternativas) {
            state.ordenesAlternativasDatos = state.ordenTrabajoAlternativas.alternativas.map(alternativa => ({
                ...alternativa,
    
                _showDetails : true,
                tieneImagenes: false
            }));
        }
    },
    'CLEAR_CONSULTA_ALTERNATIVAS' (state) {
        state.ordenTrabajoAlternativas = null;
        state.ordenesAlternativasDatos = [];
    },
    'SET_CANCELACION_SALDO_COMISION' (state, cancelacion) {
        state.vendedorComision.saldoCancelado = cancelacion.saldoCancelado;
        state.vendedorComision.fechaCancelacionSaldo = cancelacion.fechaCancelacionSaldo;
        state.vendedorComision.usuarioCancelacionSaldo = cancelacion.usuarioCancelacionSaldo;
    },
    'DELETE_CANCELACION_SALDO_COMISION' (state) {
        state.vendedorComision.saldoCancelado = false;
        state.vendedorComision.fechaCancelacionSaldo = '1900-01-01';
        state.vendedorComision.usuarioCancelacionSaldo = '';
    }
};

function setPresupuestoDatosRpt(state) {
    state.presupuestoDatosRpt = {
        numero: state.presupuestoDatos.numero,
        adicionalNumero: state.presupuestoDatos.adicionalNumero,
        presupuestoNumero: state.presupuestoDatos.presupuestoNumero,
        cliente: state.presupuestoDatos.cliente,
        accion: state.presupuestoDatos.accion,
        feeAgencia: state.presupuestoDatos.feeAgencia,
        feeAgenciaPremios: state.presupuestoDatos.feeAgenciaPremios,
        discriminarFee: state.presupuestoDatos.discriminarFee,
        cotizacion: state.presupuestoDatos.cotizacionTotal,
        pjeFinanciacion: state.presupuestoDatos.pjeFinanciacion,
        importeFinanciacion: state.presupuestoDatos.importeFinanciacion,
        discriminarPjeFinanciacion: state.presupuestoDatos.discriminarPjeFinanciacion,
        feeSobreFinanciacion: state.presupuestoDatos.feeSobreFinanciacion,
        importeFee: state.presupuestoDatos.importeFee,
        importeFeePremios: state.presupuestoDatos.importeFeePremios,
        importeDescuento: state.presupuestoDatos.importeDescuento,
        importeNeto: state.presupuestoDatos.importeNeto,
        importeImpuestos: state.presupuestoDatos.importeImpuestos,
        importeTotal: state.presupuestoDatos.importeTotal,
        moneda: state.presupuestoDatos.moneda,
        monedaCotizacion: state.presupuestoDatos.monedaCotizacion
    };
}

const getters = {
    getField,

    vistaOrdenesDatos (state) {
        return state.vistaOrdenesDatos;
    },
    presupuestoDatosRpt (state) {
        return state.presupuestoDatosRpt;
    },
    ordenesDatos (state) {
        return state.ordenesDatos;
    },
};

const actions = {
    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            let presupuestoId = 0;
            let incluirAdicionales = false;
            let query = '';

            if (params) {
                if (params.presupuestoId != 0) {
                    presupuestoId = params.presupuestoId;
                }
                if ((/true/i).test(params.incluirAdicionales)) {
                    incluirAdicionales = true;
                    query = '?incluirAdicionales=true';
                }
            }

            if (presupuestoId != 0) {
                apiAxios.get('presupuestosinternos/' + presupuestoId + query ) 
                    .then(res => {
                        let presupuestoDatos = res.data;

                        let ordenesDatos = [];
                        let datos = getDatosPresupuestoInternoRenglon();
                        for(let key in res.data.ordenesTrabajos) {
                            const orden = res.data.ordenesTrabajos[key];
                            var dest = {}; 
                            Object.keys(datos)
                                .forEach(key => dest[key] = (key in orden ? orden : datos)[key]);
                            ordenesDatos.push(dest);
                        }

                        /* Recuperamos la vista de acuerdo al usuario logueado */
                        commit('SET_VISTA_ORDENES', getVistaDatosPresupuestoInternoRenglon(incluirAdicionales));

                        let params = {
                            presupuestoDatos: presupuestoDatos,
                            ordenesDatos: ordenesDatos,
                            aperturasCierresDatos: res.data.aperturasCierres,
                            facturacion: res.data.facturacion || [],
                            usuarios: res.data.usuarios || [],
                            usuariosPropuesta: res.data.usuariosPropuesta || [],
                        }

                        commit('SET_PRESUPUESTO_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    consultarAlternativas: ({commit}, ordenTrabajoId) => {
        commit('CONSULTAR_ALTERNATIVAS', ordenTrabajoId);
    },
    clearConsultaAlternativas: ({commit}) => {
        commit('CLEAR_CONSULTA_ALTERNATIVAS');
    },
    setCancelacionSaldoComision: ( { commit }, vendedorComision ) => {
        commit('SET_CANCELACION_SALDO_COMISION', vendedorComision);
    },
    anularCancelacionSaldoComision: ( { commit } ) => {
        commit('DELETE_CANCELACION_SALDO_COMISION');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}